/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DatasetDocument } from './DatasetDocument';
import { DatasetDocumentFromJSON, DatasetDocumentFromJSONTyped, DatasetDocumentToJSON } from './DatasetDocument';

/**
 *
 * @export
 * @interface PaginatedDatasetDocumentList
 */
export interface PaginatedDatasetDocumentList {
  /**
   *
   * @type {number}
   * @memberof PaginatedDatasetDocumentList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedDatasetDocumentList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedDatasetDocumentList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<DatasetDocument>}
   * @memberof PaginatedDatasetDocumentList
   */
  results: Array<DatasetDocument>;
}

/**
 * Check if a given object implements the PaginatedDatasetDocumentList interface.
 */
export function instanceOfPaginatedDatasetDocumentList(value: object): value is PaginatedDatasetDocumentList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedDatasetDocumentListFromJSON(json: any): PaginatedDatasetDocumentList {
  return PaginatedDatasetDocumentListFromJSONTyped(json, false);
}

export function PaginatedDatasetDocumentListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedDatasetDocumentList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(DatasetDocumentFromJSON),
  };
}

export function PaginatedDatasetDocumentListToJSON(value?: PaginatedDatasetDocumentList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(DatasetDocumentToJSON),
  };
}
